import * as types from './types';

export const applyFilter = (filter) => ({
  type: types.APPLY_FILTER,
  filter,
});

export const resetFilter = () => ({
  type: types.RESET_FILTER,
});
export const updateInitialConfiguration = (initialConfiguration) => ({
  type: types.UPDATE_INITIAL_CONFIGURATION,
  initialConfiguration,
});

export const asyncHttpReqStarted = () => ({
  type: types.ASYNC_HTTP_REQ_STARTED,
});

export const asyncHttpReqEnded = () => ({
  type: types.ASYNC_HTTP_REQ_ENDED,
});

export const updateInterval = (from, to, shortcut) => ({
  type: types.INTERVAL_SELECTION,
  from,
  to,
  shortcut,
});

export const updateGranularity = (granularity) => ({
  type: types.UPDATE_GRANULARITY,
  granularity,
});

export const toggleModal = (modalType) => ({
  type: types.TOGGLE_MODAL,
  modalType,
});

export const setMappingModePreset = () => ({
  type: types.SET_MAPPING_MODE_PRESET,
});
